<template>
  <div class="side-left-container">
    <private-top class="top" />
    <private-middle class="middle" />
    <private-bottom class="bottom" />
    <private-end class="end" />
  </div>
</template>

<script>
import PrivateTop from './top'
import PrivateMiddle from './middle'
import PrivateBottom from './bottom'
import PrivateEnd from './end'

export default {
  components: { PrivateTop, PrivateMiddle, PrivateBottom, PrivateEnd }
}
</script>

<style lang="less" scoped>
.side-left-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  right: 0;
  top: 0;
  bottom: 0;
  width: 358px;
  padding: 14px;
  box-sizing: content-box;
  overflow: auto;
  .middle, .bottom, .end {
    margin-top: 14px;
  }
  .bottom {
    flex: 1;
    min-height: 300px;
  }
}
</style>
